import { useState } from 'react';
import axiosInstance from '../api/axiosInstance';

const ReportModal = ({ postId, isOpen, onClose, onReported }) => {
  const [reason, setReason] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const reasons = [
    { value: 'spam', label: 'Spam' },
    { value: 'offensive', label: 'Beleidigend/Hassrede' },
    { value: 'inappropriate', label: 'Unpassender Inhalt' },
    { value: 'harassment', label: 'Belästigung' },
    { value: 'misinformation', label: 'Fehlinformationen' },
    { value: 'copyright', label: 'Urheberrechtsverletzung' },
    { value: 'other', label: 'Anderes' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason) return;

    setLoading(true);
    try {
      await axiosInstance.post('/reports', {
        postId,
        reason,
        message
      });
      
      onReported?.();
      onClose();
      setReason('');
      setMessage('');
      
      // Success notification
      alert('Meldung erfolgreich eingereicht');
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Fehler beim Melden';
      alert(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal modal-open">
      <div className="modal-box">
        <h3 className="font-bold text-lg mb-4">Post melden</h3>
        
        <form onSubmit={handleSubmit}>
          <div className="form-control mb-4">
            <label className="label">
              <span className="label-text">Grund der Meldung *</span>
            </label>
            <select 
              className="select select-bordered" 
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              required
            >
              <option value="">Bitte wählen...</option>
              {reasons.map(r => (
                <option key={r.value} value={r.value}>
                  {r.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-control mb-4">
            <label className="label">
              <span className="label-text">Zusätzliche Informationen (optional)</span>
            </label>
            <textarea
              className="textarea textarea-bordered"
              placeholder="Weitere Details zur Meldung..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              maxLength={500}
              rows={3}
            />
            <label className="label">
              <span className="label-text-alt">{message.length}/500 Zeichen</span>
            </label>
          </div>

          <div className="modal-action">
            <button
              type="button"
              className="btn btn-ghost"
              onClick={onClose}
              disabled={loading}
            >
              Abbrechen
            </button>
            <button
              type="submit"
              className="btn btn-error"
              disabled={!reason || loading}
            >
              {loading ? (
                <span className="loading loading-spinner loading-sm"></span>
              ) : (
                '🚨 Melden'
              )}
            </button>
          </div>
        </form>
      </div>
      <div className="modal-backdrop" onClick={onClose}></div>
    </div>
  );
};

export default ReportModal;
